import { Popper, PopperProps } from '@material-ui/core';
import useStyles from './useStyles';
import cx from 'classnames';
import useIsMobile from 'hooks/useIsMobile';
import useIsLoadedInsideIframe from 'hooks/useIsLoadedInsideIframe';
interface CustomPopperProps extends PopperProps {
  isPractitionerDropdown: boolean;
  isReasonDropdown: boolean;
  isSingular: boolean;
  isForceFullWidth: boolean;
  isOneDropdownFullWidth: boolean;
  isPopperFullWidth: boolean;
}

const CustomPopper: React.FC<CustomPopperProps> = ({
  isPractitionerDropdown,
  isReasonDropdown,
  isSingular,
  isForceFullWidth,
  isOneDropdownFullWidth,
  isPopperFullWidth,
  ...props
}) => {
  const styles = useStyles();
  const isMobile = useIsMobile();

  const isLoadedInsideIframe = useIsLoadedInsideIframe();

  const popperClassName = cx({
    [styles.customPopper]: true,
    [styles.spacingContent]: isPractitionerDropdown,
    [styles.shiftPopper]:
      isPractitionerDropdown && isMobile && !isPopperFullWidth,
    [styles.shiftPopperIframe]:
      isPractitionerDropdown &&
      !isMobile &&
      isLoadedInsideIframe &&
      !isPopperFullWidth,
    [styles.fullWidth]: (isSingular && isMobile) || isPopperFullWidth,
    [styles.shiftPopperReasonIframe]:
      isReasonDropdown &&
      !isMobile &&
      isLoadedInsideIframe &&
      !isPopperFullWidth,
    [styles.forceFullWidth]: isForceFullWidth,
    [styles.resetPopperWidth]: isOneDropdownFullWidth,
  });

  return (
    <Popper
      {...props}
      className={popperClassName}
      placement="bottom"
      modifiers={{
        offset: {
          enabled: true,
        },
      }}
    />
  );
};

export default CustomPopper;
